<div class="row" *ngIf="data.length>0">
    <div class="col-12 col-sm-6 col-md-4 mb-3" *ngFor="let item of data;">
        <div class="card rounded-3 shadow">
            <div class="card-body p-0">
                <div class="gallery-container shadow">
                    <a [attr.data-src]="item.dataSrc" [attr.data-poster]="item.imgUrl[0]"
                        [attr.data-sub-html]="'<h4>' + item.title + '</h4>'">
                        <img class="img-fluid rounded-3" [src]="item.imgUrl[0]"
                            alt="{{ item.title }}" />
                        <img src="/assets/img/videos/youtube.png" alt="" class="img-fluid youtube">
                    </a>
                </div>
                <h5 class="title p-3 m-0">{{item.title}}</h5>
            </div>
        </div>
    </div>
</div>